import cn from "classnames";
import { Datetime, Field, Select } from "components/shared/form";
import { serializeReq, validateForm } from "helpers/form";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { apply, delItem, getItem } from "sources/books/admin/regionDryingPeriods";
import { config, initialState } from "./config";

export default function RegionDryingPeriodsForm(props) {
    const [data, setData] = useState(initialState);
    const [loading, setLoading] = useState(true);
    const [valid, setValid] = useState(true);
    useEffect(() => {
        if (props.data?.id) {
            getItem(props.data.id).then((res) => {
                setData(res);
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);
    const handleSubmit = () => {
        setLoading(true);
        const serialized = { ...serializeReq(data) };
        if (validateForm(config, serializeReq(data))) {
            serialized.startedAt = moment(serialized.startedAt).format("YYYY-MM-DD");
            serialized.endedAt = moment(serialized.endedAt).format("YYYY-MM-DD");
            setValid(true);
            apply(serialized).then((res) => {
                if (res) {
                    props.mergeParams();
                    props.back();
                }
                setLoading(false);
            });
        } else {
            setValid(false);
            setLoading(false);
        }
    };

    const handleDelete = () => {
        setLoading(true);
        delItem({ id: props.data.id }).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    return (
        <div className={cn({ loading, "book-form__body--invalid": !valid })}>
            <Select
                {...config.regionId}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.regionId}
            />
            <Field
                {...config.description}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.description}
            />
            <Field
                {...config.documentUrl}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.documentUrl}
            />
            <Datetime
                {...config.startedAt}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.startedAt}
            />
            <Datetime
                {...config.endedAt}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.endedAt}
            />
            <div className="d-flex justify-content-between">
                {props.data?.id ? (
                    <div className="btn btn-sm btn-danger" onClick={handleDelete}>
                        Удалить
                    </div>
                ) : (
                    <div />
                )}
                <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
